import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AmlService } from '../_services/aml.service';
import { AmlTaskEnum } from '../_models/aml-task.enum';
import { RequestBody } from '../_models/request-body';
import { SpidTaskEnum } from '../_models/spid-task.enum';
import { Task } from '../_models/task';
import { Clause } from '../_models/clause';
import { InfoDocument } from '../_models/info-document';

export const taskDataGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const amlService = inject(AmlService);
  let clauses: (Clause | InfoDocument)[] | undefined;
  let nextTask: Task<AmlTaskEnum | SpidTaskEnum> | undefined;
  let partialBody: Partial<RequestBody>;
  if (route.url[0]?.path === 'oneshot-register') {
    nextTask =
      amlService.nextTask?.name === AmlTaskEnum.ONESHOT_REGISTER ||
      amlService.nextTask?.name === SpidTaskEnum.ONESHOT_REGISTER
        ? amlService.nextTask
        : undefined;
    clauses = amlService.clausesCustomer;
    partialBody = { retry: true };
  } else {
    nextTask =
      amlService.nextTask?.name === AmlTaskEnum.SIGN ||
      amlService.nextTask?.name === SpidTaskEnum.SIGN
        ? amlService.nextTask
        : undefined;
    clauses = amlService.clausesCustomerSign;
    partialBody = { restart: true };
  }
  return checkTaskData(clauses, nextTask, partialBody, amlService, router);
};

const checkTaskData = (
  taskData: unknown,
  nextTask: Task<AmlTaskEnum | SpidTaskEnum> | undefined,
  partialBody: Partial<RequestBody> = {},
  amlService: AmlService,
  router: Router
) => {
  if (!taskData) {
    if (nextTask) {
      const extendedBody: any = {
        ...nextTask.variables,
      };
      Object.entries(extendedBody).forEach(([key, value]) => {
        if (value === 'json') {
          extendedBody[key] = JSON.stringify({});
        } else {
          extendedBody[key] = '';
        }
      });
      return amlService
        .nextAction(amlService.nextTask, {
          ...extendedBody,
          ...partialBody,
        })
        .pipe(
          map((task) => {
            const path = amlService.getPath(task);
            return router.createUrlTree(path);
          }),
          catchError(() => of(router.createUrlTree([`error`])))
        );
    } else {
      return router.createUrlTree([`error`]);
    }
  } else {
    return true;
  }
};
